<template>
  <div class="Polaris-DataTable__Footer flex">
    <div class="block">
      <p class="text-sm leading-5 text-gray-700">
        Showing
        <span class="font-medium">{{ startingPagerValue }} </span>
        to
        <span class="font-medium">{{ pagerValue }} </span>
      </p>
    </div>
    <div class="flex-1 flex justify-between sm:justify-end">
      <nav aria-label="Pagination">
        <div
          class="Polaris-ButtonGroup Polaris-ButtonGroup--segmented"
          data-buttongroup-segmented="true"
        >
          <div class="Polaris-ButtonGroup__Item">
            <button
              id="previousURL"
              class="Polaris-Button Polaris-Button--outline Polaris-Button--iconOnly"
              aria-label="Previous"
              type="button"
              @click="loadPrevPage"
              v-if="page.hasPrevPage"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Icon">
                  <span class="Polaris-Icon">
                    <span
                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                    >
                    </span>
                    <svg
                      viewBox="0 0 20 20"
                      class="Polaris-Icon__Svg"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path
                        d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                      ></path>
                    </svg>
                  </span>
                </span>
              </span>
            </button>
          </div>
          <div class="Polaris-ButtonGroup__Item">
            <button
              id="nextURL"
              class="Polaris-Button Polaris-Button--outline Polaris-Button--iconOnly"
              aria-label="Next"
              type="button"
              @click="loadNextPage"
              v-if="page.hasNextPage"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Icon">
                  <span class="Polaris-Icon">
                    <span
                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                    >
                    </span>
                    <svg
                      viewBox="0 0 20 20"
                      class="Polaris-Icon__Svg"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path
                        d="M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                      ></path>
                    </svg>
                  </span>
                </span>
              </span>
            </button>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    pagerValue() {
      const page = this.page;
      if (page) {
        if (page.total < page.limit) {
          return page.total;
        }
        if (page.page === 1) {
          return page.limit;
        }
        return page.page * page.limit;
      }
      return 0;
    },
    startingPagerValue() {
      const page = this.page;
      if (page) {
        if (page.page === 1) {
          return 1;
        }
        return (page.page - 1) * page.limit;
      }
      return 1;
    }
  },
  methods: {
    loadNextPage() {
      this.$emit("pageChanged", Number(this.page.page) + 1);
    },
    loadPrevPage() {
      this.$emit("pageChanged", Number(this.page.page) - 1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
